export default __webpack_public_path__ + "static/media/cash.3fbfb039.svg";